module.exports = __webpack_public_path__ + "img/left_gray.e80205bf.svg";